// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__D56Lb","company_logo":"Sidebar_company_logo__ZIRNQ","menu_item":"Sidebar_menu_item__l0-X4","active":"Sidebar_active__o+bvC"};